exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-child[data-v-2bb9e003] {\n  width: 400px !important;\n  justify-self: center;\n}\n.confirm-button[data-v-2bb9e003] {\n  float: right;\n}\n.date-clone-filter[data-v-2bb9e003] {\n  width: 310px !important;\n}\n.driver-clone-filter[data-v-2bb9e003] {\n  margin-left: 15px;\n  width: 300px !important;\n}\n.driver-filter[data-v-2bb9e003] {\n  margin-left: 10px;\n}\n.driver-icon[data-v-2bb9e003] {\n  position: fixed;\n}\n", ""]);

// exports
